module.exports = __webpack_public_path__ + "img/viewers-chart.45907951.svg";